export class AuthHelper {
}
AuthHelper.isUserType = (value, tokenResult) => {
    if (value in tokenResult.claims) {
        return true;
    }
    else {
        return false;
    }
};
